import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { resetComponent, textEllipsis } from '../../style';
import { genComponentStyleHook, mergeToken } from '../../theme/internal'; // ============================== Mixins ==============================

function getItemDisabledStyle(cls, token) {
  return _defineProperty({}, "".concat(cls, ", ").concat(cls, ":hover, ").concat(cls, ":focus"), {
    color: token.colorTextDisabled,
    cursor: 'not-allowed'
  });
}

function getItemSelectedStyle(token) {
  return {
    backgroundColor: token.itemSelectedBg,
    boxShadow: token.boxShadowTertiary
  };
}

var segmentedTextEllipsisCss = Object.assign({
  overflow: 'hidden'
}, textEllipsis); // ============================== Styles ==============================

var genSegmentedStyle = function genSegmentedStyle(token) {
  var _$concat, _$concat2, _$concat3, _Object$assign2;

  var componentCls = token.componentCls;
  return _defineProperty({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign2 = {
    display: 'inline-block',
    padding: token.segmentedPadding,
    color: token.itemColor,
    backgroundColor: token.segmentedBgColor,
    borderRadius: token.borderRadius,
    transition: "all ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut)
  }, _defineProperty(_Object$assign2, "".concat(componentCls, "-group"), {
    position: 'relative',
    display: 'flex',
    alignItems: 'stretch',
    justifyItems: 'flex-start',
    width: '100%'
  }), _defineProperty(_Object$assign2, "&".concat(componentCls, "-rtl"), {
    direction: 'rtl'
  }), _defineProperty(_Object$assign2, "&".concat(componentCls, "-block"), {
    display: 'flex'
  }), _defineProperty(_Object$assign2, "&".concat(componentCls, "-block ").concat(componentCls, "-item"), {
    flex: 1,
    minWidth: 0
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-item"), (_$concat = {
    position: 'relative',
    textAlign: 'center',
    cursor: 'pointer',
    transition: "color ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut),
    borderRadius: token.borderRadiusSM,
    '&-selected': Object.assign(Object.assign({}, getItemSelectedStyle(token)), {
      color: token.itemHoverColor
    }),
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      insetInlineStart: 0,
      borderRadius: 'inherit',
      transition: "background-color ".concat(token.motionDurationMid),
      // This is mandatory to make it not clickable or hoverable
      // Ref: https://github.com/ant-design/ant-design/issues/40888
      pointerEvents: 'none'
    }
  }, _defineProperty(_$concat, "&:hover:not(".concat(componentCls, "-item-selected):not(").concat(componentCls, "-item-disabled)"), {
    color: token.itemHoverColor,
    '&::after': {
      backgroundColor: token.itemHoverBg
    }
  }), _defineProperty(_$concat, "&:active:not(".concat(componentCls, "-item-selected):not(").concat(componentCls, "-item-disabled)"), {
    color: token.itemHoverColor,
    '&::after': {
      backgroundColor: token.itemActiveBg
    }
  }), _defineProperty(_$concat, '&-label', Object.assign({
    minHeight: token.controlHeight - token.segmentedPadding * 2,
    lineHeight: "".concat(token.controlHeight - token.segmentedPadding * 2, "px"),
    padding: "0 ".concat(token.segmentedPaddingHorizontal, "px")
  }, segmentedTextEllipsisCss)), _defineProperty(_$concat, '&-icon + *', {
    marginInlineStart: token.marginSM / 2
  }), _defineProperty(_$concat, '&-input', {
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    width: 0,
    height: 0,
    opacity: 0,
    pointerEvents: 'none'
  }), _$concat)), _defineProperty(_Object$assign2, "".concat(componentCls, "-thumb"), Object.assign(Object.assign({}, getItemSelectedStyle(token)), _defineProperty({
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    width: 0,
    height: '100%',
    padding: "".concat(token.paddingXXS, "px 0"),
    borderRadius: token.borderRadiusSM
  }, "& ~ ".concat(componentCls, "-item:not(").concat(componentCls, "-item-selected):not(").concat(componentCls, "-item-disabled)::after"), {
    backgroundColor: 'transparent'
  }))), _defineProperty(_Object$assign2, "&".concat(componentCls, "-lg"), (_$concat2 = {
    borderRadius: token.borderRadiusLG
  }, _defineProperty(_$concat2, "".concat(componentCls, "-item-label"), {
    minHeight: token.controlHeightLG - token.segmentedPadding * 2,
    lineHeight: "".concat(token.controlHeightLG - token.segmentedPadding * 2, "px"),
    padding: "0 ".concat(token.segmentedPaddingHorizontal, "px"),
    fontSize: token.fontSizeLG
  }), _defineProperty(_$concat2, "".concat(componentCls, "-item, ").concat(componentCls, "-thumb"), {
    borderRadius: token.borderRadius
  }), _$concat2)), _defineProperty(_Object$assign2, "&".concat(componentCls, "-sm"), (_$concat3 = {
    borderRadius: token.borderRadiusSM
  }, _defineProperty(_$concat3, "".concat(componentCls, "-item-label"), {
    minHeight: token.controlHeightSM - token.segmentedPadding * 2,
    lineHeight: "".concat(token.controlHeightSM - token.segmentedPadding * 2, "px"),
    padding: "0 ".concat(token.segmentedPaddingHorizontalSM, "px")
  }), _defineProperty(_$concat3, "".concat(componentCls, "-item, ").concat(componentCls, "-thumb"), {
    borderRadius: token.borderRadiusXS
  }), _$concat3)), _Object$assign2)), getItemDisabledStyle("&-disabled ".concat(componentCls, "-item"), token)), getItemDisabledStyle("".concat(componentCls, "-item-disabled"), token)), _defineProperty({}, "".concat(componentCls, "-thumb-motion-appear-active"), {
    transition: "transform ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut, ", width ").concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut),
    willChange: 'transform, width'
  })));
}; // ============================== Export ==============================


export default genComponentStyleHook('Segmented', function (token) {
  var lineWidth = token.lineWidth,
      lineWidthBold = token.lineWidthBold,
      colorBgLayout = token.colorBgLayout;
  var segmentedToken = mergeToken(token, {
    segmentedPadding: lineWidthBold,
    segmentedBgColor: colorBgLayout,
    segmentedPaddingHorizontal: token.controlPaddingHorizontal - lineWidth,
    segmentedPaddingHorizontalSM: token.controlPaddingHorizontalSM - lineWidth
  });
  return [genSegmentedStyle(segmentedToken)];
}, function (token) {
  var colorTextLabel = token.colorTextLabel,
      colorText = token.colorText,
      colorFillSecondary = token.colorFillSecondary,
      colorBgElevated = token.colorBgElevated,
      colorFill = token.colorFill;
  return {
    itemColor: colorTextLabel,
    itemHoverColor: colorText,
    itemHoverBg: colorFillSecondary,
    itemSelectedBg: colorBgElevated,
    itemActiveBg: colorFill
  };
});